import { render, staticRenderFns } from "./JournalView.vue?vue&type=template&id=7a4758c6&scoped=true"
import script from "./JournalView.vue?vue&type=script&lang=js"
export * from "./JournalView.vue?vue&type=script&lang=js"
import style0 from "./JournalView.vue?vue&type=style&index=0&id=7a4758c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4758c6",
  null
  
)

export default component.exports